import { produce, Draft } from 'immer'
import { IAction } from '@Root/types'
import filter from 'lodash/filter'
import map from 'lodash/map'

import {
  IExportationState,
  TExportationActionTypes,
  ExportationActionTypes,
} from './types'

import {
  IGetFollowedExportationsSuccessPayload,
  IAddFollowedExportationPayload,
  IRemoveFollowedExportationPayload,
} from '@EditorModules/Exportation/types'

export const initialState: IExportationState = {
  followedExportations: [],
  followedExportationIds: [],
}

type TAction = TExportationActionTypes

export const exportationsReducer = (
  state: IExportationState = initialState,
  action: TAction,
): IExportationState => {
  return produce(state, draft => {
    switch (action.type) {
      case ExportationActionTypes.GET_FOLLOWED_EXPORTATIONS_SUCCESS:
        getFollowedExportationsSuccess(draft, action)
        break

      case ExportationActionTypes.ADD_FOLLOWED_EXPORTATION:
        addFollowedExportation(draft, action)
        break

      case ExportationActionTypes.REMOVE_FOLLOWED_EXPORTATION:
        removeFollowedExportation(draft, action)
        break

      default:
        break
    }
  })
}

function isGetFollowedExportationsSuccessAction(arg: any): arg is IAction<IGetFollowedExportationsSuccessPayload> {
  return arg.type === ExportationActionTypes.GET_FOLLOWED_EXPORTATIONS_SUCCESS
}

function getFollowedExportationsSuccess(draft: Draft<IExportationState>, action: TExportationActionTypes) {
  if (!isGetFollowedExportationsSuccessAction(action)) { return }

  draft.followedExportations = map(action.payload!.data, exportation => {
    return { ...exportation, id: Number(exportation.id) }
  })
}

function isAddFollowedExportationAction(arg: any): arg is IAction<IAddFollowedExportationPayload> {
  return arg.type === ExportationActionTypes.ADD_FOLLOWED_EXPORTATION
}

function addFollowedExportation(draft: Draft<IExportationState>, action: TExportationActionTypes) {
  if (!isAddFollowedExportationAction(action)) { return }

  draft.followedExportationIds.push(action.payload!.exportationId)
}

function isRemoveFollowedExportationAction(arg: any): arg is IAction<IRemoveFollowedExportationPayload> {
  return arg.type === ExportationActionTypes.REMOVE_FOLLOWED_EXPORTATION
}

function removeFollowedExportation(draft: Draft<IExportationState>, action: TExportationActionTypes) {
  if (!isRemoveFollowedExportationAction(action)) { return }

  draft.followedExportationIds = filter(draft.followedExportationIds, id => id !== action.payload!.exportationId)
  draft.followedExportations = filter(draft.followedExportations, exportation => exportation.id !== action.payload!.exportationId)
}